import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title, 
  description, 
  keywords, 
  ogImage = '/logo.jpg',
  canonical,
  section = 'home'
}) => {
  const fullTitle = title ? `Samapaw - ${title} | Samapaw Sampatti Pvt Ltd` : `Samapaw | Samapaw Sampatti - Leading Wealth Management Company Gurugram`;
  
  const defaultDescription = 'Samapaw - Official website of Samapaw Sampatti Pvt Ltd, leading wealth management & property investment company in Gurugram. Expert Samapaw portfolio management, business debt provision & financial consultation services since 2022.';
  const metaDescription = description || defaultDescription;
  
  const defaultKeywords = 'Samapaw, Samapaw Sampatti, Samapaw Sampatti Pvt Ltd, Samapaw wealth management, Samapaw Sampatti Gurugram, wealth management, portfolio management, property investment, business debt provision, financial consultation, investment advisory, real estate investment, Gurugram, Haryana, India, asset management, financial planning, Sama paw, Samaapaw';
  const metaKeywords = keywords || defaultKeywords;
  
  const canonicalUrl = canonical || `https://samapaw.com${section !== 'home' ? `/#${section}` : ''}`;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={metaDescription} />
      <meta name="keywords" content={metaKeywords} />
      
      {/* Open Graph Meta Tags */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:image" content={`https://samapaw.com${ogImage}`} />
      <meta property="og:url" content={canonicalUrl} />
      
      {/* Twitter Card Meta Tags */}
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={`https://samapaw.com${ogImage}`} />
      
      {/* Canonical URL */}
      <link rel="canonical" href={canonicalUrl} />
      
      {/* Additional Meta Tags Based on Section */}
      {section === 'services' && (
        <>
          <meta name="service-type" content="financial services" />
          <meta name="business-category" content="wealth management" />
        </>
      )}
      
      {section === 'about' && (
        <>
          <meta name="company-founded" content="2022" />
          <meta name="company-type" content="Private Limited" />
        </>
      )}
      
      {section === 'contact' && (
        <>
          <meta name="contact-phone" content="+918287133175" />
          <meta name="contact-email" content="samapawsampatti@gmail.com" />
          <meta name="business-hours" content="Mon-Fri 9:00 AM - 6:00 PM" />
        </>
      )}
    </Helmet>
  );
};

export default SEO;